export default "/images/vendor/@coreui/icons/svg/flag/cif-in.svg?b2430c1edeec6a6f1b729753419ace44";